import React from 'react'
import styles from './styles.module.css' // Ensure this is the correct path to your CSS module

import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg' // adjust path if needed

function MostRecentRentalPriceDate ({
  mostRecentRentalListPriceDateFilter,
  setMostRecentRentalListPriceDateFilter
}) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartDateChange = e => {
    setMostRecentRentalListPriceDateFilter({
      ...mostRecentRentalListPriceDateFilter,
      startDate: e.target.value
    })
  }

  const handleEndDateChange = e => {
    setMostRecentRentalListPriceDateFilter({
      ...mostRecentRentalListPriceDateFilter,
      endDate: e.target.value
    })
  }

  return (
    <div className={styles.RecentStatusDateContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.RecentStatusDateTitle}>
          Most recent rental list price date
        </h1>
        <Tooltip
          title="Filter by the date when a property’s most recent rental list price was recorded. Set a start and/or end date to narrow results."
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Most recent rental price date info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.RecentStatusDateInputContainer}>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='startDate'
          max={maxDate}
          value={mostRecentRentalListPriceDateFilter.startDate}
          onChange={handleStartDateChange}
          required
        />
        <span className={styles.RecentStatusDateLabel}>to</span>
        <input
          className={styles.RecentStatusDateInput}
          type='date'
          name='endDate'
          max={maxDate}
          value={mostRecentRentalListPriceDateFilter.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>
    </div>
  )
}

export default MostRecentRentalPriceDate
